import { render, staticRenderFns } from "./FormBox.vue?vue&type=template&id=cc387a24&scoped=true"
import script from "./FormBox.vue?vue&type=script&lang=js"
export * from "./FormBox.vue?vue&type=script&lang=js"
import style0 from "./FormBox.vue?vue&type=style&index=0&id=cc387a24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc387a24",
  null
  
)

export default component.exports